export const followUp = {
  button: {
    label: "Follow up",
  },
  header: "Follow up",
  new: "New follow up",
};
